export const AUTH_ROUTES = [
  {
    path: 'sign-in/:catchAll(.*)*',
    name: 'SignIn',
    component: () => import('./views/SignIn.vue'),
  },
  {
    path: 'sign-up/:catchAll(.*)*',
    name: 'SignUp',
    component: () => import('./views/SignUp.vue'),
  },
  {
    path: 'organizations/create',
    name: 'CreateOrganization',
    component: () => import('./organizations/views/CreateOrganization.vue'),
  },
]
